import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EcrirePage } from './ecrire';

@NgModule({
  declarations: [
    EcrirePage,
  ],
  imports: [
    IonicPageModule.forChild(EcrirePage),
  ],
})
export class EcrirePageModule {}



// WEBPACK FOOTER //
// ./src/pages/ecrire/ecrire.module.ts